import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// Détection plateforme
export const isNative = () => Capacitor.isNativePlatform();
export const isIOS = () => Capacitor.getPlatform() === 'ios';
export const isAndroid = () => Capacitor.getPlatform() === 'android';
export const isWeb = () => Capacitor.getPlatform() === 'web';

// Storage abstraction : Preferences natif sur iOS/Android, localStorage sur web
export const storage = {
  async get(key) {
    if (isNative()) {
      const { value } = await Preferences.get({ key });
      return value;
    }
    return localStorage.getItem(key);
  },
  async set(key, value) {
    if (isNative()) {
      await Preferences.set({ key, value: String(value) });
      return;
    }
    localStorage.setItem(key, value);
  },
  async remove(key) {
    if (isNative()) {
      await Preferences.remove({ key });
      return;
    }
    localStorage.removeItem(key);
  },
  async clear() {
    if (isNative()) {
      await Preferences.clear();
      return;
    }
    localStorage.clear();
  },
};
